import React from 'react';

const WarehouseSection = () => {
  return (
    <section className="warehouse-split">
      <div className="warehouse-split-card">
        <div className="warehouse-split-media">
          <div className="warehouse-split-media-inner" style={{ backgroundImage: 'url(/it_disposition.jpg)' }}></div>
        </div>
        <div className="warehouse-split-left">
          <h2 className="warehouse-split-title warehouse-split-title-xl">
            Secure Data Destruction & Asset Recovery
          </h2>
          <p className="warehouse-split-desc">
            Our certified technicians combine advanced data destruction technology with meticulous asset evaluation to ensure your sensitive information is completely erased while maximizing recovery value from your retired IT equipment.
          </p>
          <ul className="warehouse-split-bullets warehouse-split-bullets-icons">
            <li><span className="warehouse-badge" aria-hidden>▣</span>NIST 800-88 compliant data destruction using certified software and physical destruction methods for complete data security.</li>
            <li><span className="warehouse-badge" aria-hidden>▣</span>Professional asset evaluation and grading system to determine optimal recovery channels for maximum value return.</li>
            <li><span className="warehouse-badge" aria-hidden>▣</span>Certified technicians trained in IT asset management, ensuring meticulous attention to detail in every aspect of data security and asset handling.</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default WarehouseSection;
